import React, { useEffect, useState } from "react";
import { Header } from "../components/ui/header";
import { money } from "../utilities/currency";
import axios from "axios";
import { Footer } from "../components/ui/footer";
type vilkarPageProps = {
    currentUser: any,
    onLogout: any,
    baseUrl: string,
    onLoginClick: any,
    onLoginSuccess: any,
}
const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};
export default function VilkarBookingCancelPage({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess}: vilkarPageProps) {
    const [wallet, setWallet] = useState(0);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])
    return (
        <div className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} />
            <div className="min-h-screen bg-slate-200 flex items-center justify-center py-16 px-6 md:px-12 lg:px-24">
                <div className="bg-white w-full max-w-4xl rounded-2xl shadow-xl p-8 space-y-6">
                    <h1 className="text-3xl font-bold text-slate-800 text-center">
                        Vilkår for Betaling og Avbestilling
                    </h1>

                    <div className="space-y-4 text-slate-700 text-sm leading-6 pr-2">
                        <p>Disse vilkårene gjelder for alle konsultasjoner og tjenester levert via plattformen.</p>

                        <h2 className="font-semibold text-slate-900">1. Betalingsautorisasjon</h2>
                        <p>Ved bestilling av en konsultasjon foretas en betalingsautorisasjon tilsvarende hele konsultasjonens kostnad. Autorisasjonen er en reservasjon og blir ikke belastet før konsultasjonen er gjennomført.</p>

                        <h3 className="font-medium text-slate-900">1.1 Drop-in kunder</h3>
                        <p>Ved drop-in-konsultasjoner autoriseres et beløp basert på kundens valgte lengde på konsultasjonen. Dersom konsultasjonen avsluttes tidligere enn valgt varighet, belastes kun forbrukt tid og resterende beløp frigis automatisk. Kunden betaler altså kun for faktisk brukt tid.</p>

                        <h2 className="font-semibold text-slate-900">2. Avbestilling</h2>
                        <p>Du kan avbestille konsultasjonen via din brukerportal frem til starttidspunktet.</p>

                        <h3 className="font-medium text-slate-900">2.1 Avbestilling mer enn 24 timer før</h3>
                        <ul className="list-disc ml-5">
                            <li>Ingen kostnad.</li>
                            <li>Betalingsautorisasjonen annulleres i sin helhet.</li>
                        </ul>

                        <h3 className="font-medium text-slate-900">2.2 Avbestilling mindre enn 24 timer før</h3>
                        <ul className="list-disc ml-5">
                            <li>Ved avbestilling eller ombooking under 24 timer før start belastes fullt <strong>no-show-gebyr</strong>.</li>
                            <li>Drop-in-tjenester har ingen angrerett og kan ikke refunderes etter igangsettelse.</li>
                            <li>Fullt <strong>no-show-gebyr</strong> belastes, tilsvarende konsultasjonens totalpris.</li>
                            <li>Dette er i tråd med vanlige bransjepraksiser og norsk lovgivning (avtaleloven, markedsføringsloven, angrerettloven).</li>
                        </ul>

                        <h2 className="font-semibold text-slate-900">3. Uteblivelse (No-show)</h2>
                        <p>Dersom du ikke møter til avtalt tid, anses dette som no-show og fullt gebyr belastes.</p>

                        <h2 className="font-semibold text-slate-900">4. Refusjon</h2>
                        <p>Det gis ingen refusjon for avbestilling mindre enn 24 timer før avtalt start, eller ved no-show.</p>

                        <h2 className="font-semibold text-slate-900">5. Endring av tidspunkt</h2>
                        <p>Endring av tidspunkt anses som avbestilling dersom det skjer mindre enn 24 timer før avtalt start.</p>

                        <h2 className="font-semibold text-slate-900">6. Leverandørens rettigheter</h2>
                        <ul className="list-disc ml-5">
                            <li>kansellere eller endre tidspunkt ved uforutsette hendelser,</li>
                            <li>tilbakeholde betaling ved brudd på vilkår,</li>
                            <li>oppdatere vilkårene løpende.</li>
                        </ul>

                        <h2 className="font-semibold text-slate-900">7. Aksept</h2>
                        <p>Ved å bestille eller avbestille aksepterer du disse vilkårene i sin helhet.</p>
                    </div>
                </div>
            </div>
            <Footer baseUrl={baseUrl} />
        </div>
    );
}
